import type { WebhookLogReplayDto } from "@/api/dtos";
import type { WebhookLogReplay, WebhookOutcome } from "@/api/webhook-log/_models/WebhookLog";

export const toWebhookLogReplayFromWebhookLogReplayDto = (dto: WebhookLogReplayDto): WebhookLogReplay => {
  return {
    replayId: dto.replayId,
    replayOf: dto.replayOf,
    outcome: dto.outcome as WebhookOutcome,
    error: dto.error ?? undefined,
  };
};
